import React, { Component } from 'react';
import { ScrollLayout } from '../containers/Layout';
import SwipeableTabs from '../../../../commonModules/MUI/SwipeableTabs';
import PopUp from '../../../../commonModules/interface/PopUp';

import UpdateSAV from './UpdateSAV';
import TimeLineSAV from './TimeLineSAV';
import { Box } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { isEmpty, reverse } from 'lodash';
import { sortByDateReverse } from '../../../../../../../jsx/actions/utils';

class InfoSAV extends Component {
    state = { 
        headerMenu: "ACTIONS",
    }

    orderByActionDates = (list) => {
        let orderTmp = {}
        let ordered = []
        list.forEach(element => {
            orderTmp[element.action_ts] = element
        });

        Object.keys(orderTmp)
        //orderBy
        return sortByDateReverse(list, "action_ts")
    }
    render() {
        let history = []
        if (!isEmpty(this.props.sav.sav_actions)){
            history = sortByDateReverse([...this.props.sav.sav_actions], "action_ts")
        } else {
            history = this.props.sav.sav_actions ? [...this.props.sav.sav_actions] : []
        }
        return (
            <PopUp
                title={`SAV n° ${this.props.sav.id.slice(0,13)} | ${this.props.productName} - ${this.props.productBrand}`}
                close={this.props.closePopup}
                appbar
            >                
                <Box>
                {/* <Box style={{ position: "relative"}}> */}
                    {/* <Alert severity="info" >
                        <AlertTitle><b>{this.props.productName}</b> - {this.props.productBrand}</AlertTitle>
                        Quantité: {this.props.sav.sav_quantity}
                    </Alert>                    */}
                    <UpdateSAV {...this.props} />     
                    <Box>
                        <TimeLineSAV history={history}/>
                        {/* <TimeLineSAV history={this.props.sav.sav_actions}/> */}
                    </Box>
                </Box>
            </PopUp>
        );
    }
}

export default InfoSAV;